import { useProgress } from "@react-three/drei";
import React from "react";
import "./Loading.style.css";

const LoadingScene = () => {
    const { progress } = useProgress();
    console.log(progress);
    return (
        <div className="loading-bg">
            <div className="loading-planet"></div>
            <div className="loadingtext">Loading {progress.toFixed(0)} %</div>
        </div>
    );
};

export default LoadingScene;
